// Delade formatterare för watchlist och screener.

export function fmtNumber(n: number | undefined, opts?: Intl.NumberFormatOptions): string {
  if (n === undefined || n === null) return '—';
  return new Intl.NumberFormat('sv-SE', opts).format(n);
}

export function fmtMarketCap(n: number | undefined): string {
  if (!n) return '—';
  if (n >= 1e12) return `${(n / 1e12).toFixed(2)} T`;
  if (n >= 1e9) return `${(n / 1e9).toFixed(2)} mdr`;
  if (n >= 1e6) return `${(n / 1e6).toFixed(1)} M`;
  return fmtNumber(n);
}

/**
 * RSI-färgsättning med flera nivåer:
 *   >= 70: röd (överköpt)
 *   >= 65: orange (varnar, nära överköpt)
 *   <= 30: grön (översåld)
 *   <= 35: lime (varnar, nära översåld)
 *   annars: neutral
 *
 * Returnerar Tailwind-klasser som finns i tailwind.config.js safelist.
 */
export function rsiStyle(rsi: number | undefined): string {
  if (rsi === undefined || rsi === null) return 'text-slate-500 dark:text-slate-400';
  if (rsi >= 70) return 'text-red-600 dark:text-red-400 font-semibold';
  if (rsi >= 65) return 'text-orange-600 dark:text-orange-400 font-semibold';
  if (rsi <= 30) return 'text-green-600 dark:text-green-400 font-semibold';
  if (rsi <= 35) return 'text-lime-600 dark:text-lime-400 font-semibold';
  return 'text-slate-700 dark:text-slate-200';
}

export function rsiLabel(rsi: number | undefined): string {
  if (rsi === undefined || rsi === null) return '—';
  if (rsi >= 70) return `${rsi.toFixed(1)} ⚠`;
  if (rsi >= 65) return `${rsi.toFixed(1)} ↑`;
  if (rsi <= 30) return `${rsi.toFixed(1)} ✓`;
  if (rsi <= 35) return `${rsi.toFixed(1)} ↓`;
  return rsi.toFixed(1);
}
